//ພາສາຈີນ
export default {
  tip: {
    fromSuccess: "ການສົ່ງສຳເລັດແລ້ວ",
  },
  login: {
    linkList: [
      { name: "ສູນການຄ້າ Star Points", url: "/" },
      {
        name: "ລົງທະບຽນເປັນພໍ່ຄ້າ",
        url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
      },
    ],
    registered: {
      text: "ບໍ່ມີບັນຊີບໍ? ຄລິກເພື່ອລົງທະບຽນ>>",
      url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
    },
    shouye: {
      url: "/",
    },
    forgot: "ລືມລະຫັດຜ່ານບໍ?",
    title: "ເຂົ້າສູ່ລະບົບບັນຊີ",

    email: "ທີ່ຢູ່ອີເມວ",

    pwd: "ລະຫັດຜ່ານ",

    denglu: "ເຂົ້າສູ່ລະບົບ",

    mima: "ລືມລະຫັດຜ່ານ",

    Reset: "ຕັ້ງຄ່າລະຫັດຜ່ານໃໝ່",

    p_email: "ກະລຸນາໃສ່ທີ່ຢູ່ອີເມວຂອງທ່ານ",

    p_pwd: "ກະລຸນາໃສ່ລະຫັດຜ່ານຂອງທ່ານ",

    p_new_pwd: "ກະລຸນາໃສ່ລະຫັດຜ່ານໃໝ່ຂອງທ່ານ",

    z_email: "ກະລຸນາໃສ່ທີ່ຢູ່ອີເມວທີ່ຖືກຕ້ອງ",

    long: "ຄວາມຍາວລະຫວ່າງ 6 ຫາ 18 ຕົວອັກສອນ",

    determine: "ຢືນຢັນ",

    Valid:
      "ຄຳຮ້ອງຂໍການຕັ້ງຄ່າລະຫັດຜ່ານໃໝ່ໄດ້ຖືກສົ່ງໄປແລ້ວ. ກະລຸນາກວດສອບອີເມວຂອງທ່ານສຳລັບລິ້ງຕັ້ງຄ່າໃໝ່. ລິ້ງນີ້ໃຊ້ໄດ້ເປັນເວລາ 24 ຊົ່ວໂມງ!",

    Help_reset:
      "ໃສ່ທີ່ຢູ່ອີເມວທີ່ລົງທະບຽນຂອງທ່ານ, ແລະພວກເຮົາຈະຊ່ວຍທ່ານຕັ້ງຄ່າລະຫັດຜ່ານຂອງທ່ານຄືນໃໝ່.",
  },
  myhead: {
    loginName: "ເຂົ້າສູ່ລະບົບ",
    Personalcenter: "ສູນສ່ວນຕົວ",
    placeholder: "ກະລຸນາໃສ່...",
    myhead_a: "ໜ້າຫຼັກ",
    myhead_b: "ການຊື້ຂາຍ",
    myhead_bc: "ແພລດຟອມການຊື້ຂາຍ",
    myhead_c: "ແພລດຟອມ",
    myhead_d: "ສະຖາບັນການຊື້ຂາຍ",
    myhead_e: "ກ່ຽວກັບພວກເຮົາ",
    myhead_f: "Interstellar ຊ່ວຍທ່ານ",
    myhead_g: "ກາຍເປັນພໍ່ຄ້າທີ່ດີທີ່ສຸດ",
    myhead_h: "ເປີດບັນຊີແທ້",
    myhead_i: "ເລີ່ມບັນຊີສາທິດ",
    myhead_j: {
      text: "ກິດຈະກຳການຕະຫຼາດ",
      url: "https://www.interstellarfx.net/zh/trade-cashback",
    },
    myhead_k: "ການຊື້ຂາຍເງິນຄືນ",
    myhead_l: "ຜະລິດຕະພັນການຊື້ຂາຍ",
    myhead_m: "ກ່ຽວກັບການຊື້ຂາຍ",

    myhead_n: "ສະຖາບັນ Forex",

    myhead_o: "ກິດຈະກຳມອບລາງວັນຄະແນນງານບຸນກາງລະດູໃບໄມ້ຫຼົ່ນ",

    myhead_p: "ການປະກາດລະຫວ່າງດວງດາວ",

    myhead_q: "ການຄາດຄະເນຕະຫຼາດ",

    myhead_r:
      "ສັນຍາສຳລັບຄວາມແຕກຕ່າງ (CFDs) ແມ່ນຜະລິດຕະພັນການຊື້ຂາຍທາງການເງິນທີ່ສັບສົນເຊິ່ງມີຄວາມສ່ຽງສູງຕໍ່ການສູນເສຍຢ່າງໄວວາເນື່ອງຈາກການໃຊ້ leverage. ບັນຊີນັກລົງທຶນຂາຍຍ່ອຍສ່ວນໃຫຍ່ຈະສູນເສຍເງິນເມື່ອຊື້ຂາຍ CFDs. ທ່ານຄວນພິຈາລະນາວ່າທ່ານເຂົ້າໃຈຢ່າງເຕັມສ່ວນວ່າ CFDs ເຮັດວຽກແນວໃດ ແລະ ທ່ານສາມາດທີ່ຈະສ່ຽງຕໍ່ການສູນເສຍເງິນຂອງທ່ານໄດ້ຫຼືບໍ່.",
    myhead_s: "ບໍລິສັດ",
    myhead_t: "ຕະຫຼາດ",
    myhead_u: "ລາຄາ",
    myhead_v: "ການວິເຄາະ ແລະ ການສຶກສາ",
    myhead_v_a: "ການວິເຄາະ",
    myhead_v_b: "ການສຶກສາ",
    myhead_w: "ລະບຽບການ",
    myhead_x: "ປະກັນໄພ",
    myhead_y: "ການປະຕິບັດຕາມກົດໝາຍ",
    myhead_z: "ຂ່າວລ່າສຸດ",
    myhead_aa: "ຄູ່ມືການຊື້ຂາຍ",
    myhead_bb: "ຄຳສັບການຊື້ຂາຍ",
    myhead_cc: "ຂ່າວສົດ",
    myhead_dd: "ການວິເຄາະການຊື້ຂາຍ",
    myhead_ee: "ການລົງທຶນ Forex",
    myhead_ff: "ການສະໜັບສະໜູນກິດຈະກຳ ແລະ ຄວາມຮັບຜິດຊອບຕໍ່ສັງຄົມ",
    myhead_gg: "ກອງປະຊຸມສຳມະນາຜ່ານເວັບ ISG",
    myhead_hh: "ການວິເຄາະ FISG",
    myhead_ii: "ຫຼັກສູດການຊື້ຂາຍ",
    myhead_com: "ການແຂ່ງຂັນການຊື້ຂາຍສາທິດ InterStellar Group",
  },
  Home: {
    Home_a: "ແລກຄະແນນຂອງທ່ານເປັນຂອງຂວັນພິເສດສຳລັບຕົວທ່ານເອງ!",
    Home_b: "",
    Home_c:
      "ແລກຄະແນນຂອງທ່ານເປັນຂອງຂວັນສຸດພິເສດເຊັ່ນ: ແຟຊັ່ນດິຈິຕອນ, ເຄື່ອງໃຊ້ໄຟຟ້າສຸດຫຼູ, ລົດຫຼູ ແລະ ສິນຄ້າອື່ນໆໄດ້ທຸກເວລາ",
    // Home_a: 'ສູນການຄ້າ InterStellar Points',
    // Home_b: 'ແລກປ່ຽນເພື່ອຮັບຄະແນນ, ແລກຄະແນນເພື່ອຮັບຂອງຂວັນທີ່ໜ້າອັດສະຈັນ!',
    // Home_c:
    //   'ແລກຄະແນນແລກປ່ຽນຂອງທ່ານເພື່ອຮັບຂອງຂວັນທີ່ດີເລີດ, ລວມທັງຜະລິດຕະພັນດິຈິຕອນທີ່ທັນສະໄໝ, ເຄື່ອງໃຊ້ໄຟຟ້າທີ່ງົດງາມ, ລົດຫຼູຫຼາຊັ້ນນຳ, ແລະສິນຄ້າທີ່ດີອື່ນໆອີກຫຼາຍຢ່າງ...',
    Home_d: "ເບິ່ງເງື່ອນໄຂ ແລະ ຂໍ້ກຳນົດຂອງງານ",
    Home_e: "ຄລິກ",
    Home_f: "ທີ່ນີ້",
    Home_g: "ຂອງຂວັນທີ່ດີເລີດຫຼາກຫຼາຍຊະນິດລໍຖ້າທ່ານຢູ່",
    Home_h: "ບໍ່ພົບຂອງຂວັນທີ່ທ່ານຕ້ອງການບໍ?",
    Home_i:
      "ພວກເຮົາຍິນດີຕ້ອນຮັບຄຳແນະນຳຂອງທ່ານກ່ຽວກັບຜະລິດຕະພັນທີ່ຕ້ອງການ.ພວກເຮົາຈະເຕີມເຕັມຜະລິດຕະພັນຂອງພວກເຮົາໂດຍອີງໃສ່ຄວາມນິຍົມຂອງຄໍາແນະນໍາຂອງທ່ານ...",

    Home_j: "ຍີ່ຫໍ້ຂອງຂວັນ: ເຊັ່ນ Xiaomi, Huawei...",

    Home_k:
      "ລາຍລະອຽດຜະລິດຕະພັນ: ເຊັ່ນ Xiaomi Electric Plus Ninebot Balance Scooter...",

    Home_l: "ສົ່ງ",

    Home_m: "ກົດລະບຽບສໍາລັບການແລກຂອງຂວັນຄະແນນ",

    Home_n: "ວິທີການຮັບຄະແນນ",

    Home_o:
      "ລູກຄ້າ FISG ໃດໆທີ່ຊື້ຂາຍຄູ່ສະກຸນເງິນ, ໂລຫະທີ່ມີຄ່າ, ແລະຜະລິດຕະພັນພະລັງງານໃນແພລດຟອມຂອງພວກເຮົາຈະໄດ້ຮັບ 1 ຄະແນນສໍາລັບທຸກໆ lot ທີ່ຊື້ຂາຍ (ຄໍາສັ່ງຊື້ຂາຍທີ່ຖືໄວ້ຫຼາຍກວ່າສາມນາທີຖືວ່າຖືກຕ້ອງ).",

    Home_p: "ວິທີການແລກຂອງຂວັນ",

    Home_q:
      "ສົ່ງໃບສະໝັກແລກໃນສູນຄະແນນ (ທ່ານຕ້ອງຕື່ມຊື່, ຂໍ້ມູນຕິດຕໍ່, ແລະຂໍ້ມູນບັນຊີການຊື້ຂາຍ, ແລະອື່ນໆ). ແບັກເອັນຈະທົບທວນຄືນຄະແນນແລະກິດຈະກໍາການຊື້ຂາຍທີ່ຜ່ານມາຂອງທ່ານ. ຂອງຂວັນຈະຖືກສົ່ງຫຼັງຈາກການອະນຸມັດ.",
    Home_r: "ເວລາຈັດສົ່ງຂອງຂວັນ",

    Home_s:
      "ຂອງຂວັນຈະຖືກຈັດສົ່ງພາຍໃນ 15 ມື້ຫຼັງຈາກໃບສະໝັກແລກຂອງທ່ານໄດ້ຮັບການອະນຸມັດ. ກະລຸນາກວດສອບຈົດໝາຍຂອງທ່ານ. ທ່ານຍັງສາມາດຕິດຕໍ່ຜູ້ຈັດການບໍລິການລູກຄ້າທີ່ອຸທິດຕົນຂອງທ່ານເພື່ອກວດສອບຄວາມຄືບໜ້າຂອງການຈັດສົ່ງ.",

    Home_t: "ແຈ້ງການຫຼັງການຂາຍ",

    Home_u:
      "ຜະລິດຕະພັນທັງໝົດທີ່ລະບຸໄວ້ໃນ Points Mall ແມ່ນສະໜອງໃຫ້ໂດຍຜູ້ສະໜອງພາກສ່ວນທີສາມ ແລະ ບໍ່ຮອງຮັບການສົ່ງຄືນໂດຍບໍ່ມີເຫດຜົນ. ເຖິງຢ່າງໃດກໍ່ຕາມ, ຖ້າຂອງຂວັນທີ່ບໍ່ຖືກຕ້ອງຖືກສົ່ງມາ ຫຼື ສິນຄ້າເສຍຫາຍໃນລະຫວ່າງການຈັດສົ່ງ, ກະລຸນາຕິດຕໍ່ຕົວແທນບໍລິການລູກຄ້າຂອງທ່ານເພື່ອຂໍຄວາມຊ່ວຍເຫຼືອ.",
    Home_v: "ຄຳແນະນຳທີ່ນິຍົມ",
    Home_w:
      "ຍີ່ຫໍ້ທີ່ທັນສະໄໝຫຼາຍຢ່າງ, ແລກດ້ວຍຄະແນນ FISG, ສິນຄ້າທີ່ທັນສະໄໝທີ່ສຸດກຳລັງລໍຖ້າທ່ານຢູ່ທີ່ນີ້",
    Home_x: "ແລກດຽວນີ້",
    Home_y: "ຄະແນນ",
    Home_z: "ຍີ່ຫໍ້ທີ່ໂດດເດັ່ນ",
    Home_aa: "ສິນຄ້າມາໃໝ່",
    Home_bb: "ການຈັດຮຽງຄະແນນ",
    Home_cc: "ຍີ່ຫໍ້ທີ່ໂດດເດັ່ນ",
    Home_dd: "ຕ້ອງການເທົ່ານັ້ນ",
    Home_ee: "ແລກດ້ວຍຄະແນນ",
    Home_ff: "ກະລຸນາໃສ່ຍີ່ຫໍ້ຂອງຂວັນ",
    Home_gg: "ກະລຸນາໃສ່ລາຍລະອຽດຜະລິດຕະພັນ",
    Home_hh: "ສຳເລັດ",
    Home_hh: "ເງື່ອນໄຂ",
    Home_ii: "ສຳເລັດ",
    Home_zz: "ສູນຄະແນນ Interstellar",
    Home_kk: "ຄະແນນ Mall",
    Home_search: "ຄົ້ນຫາຜະລິດຕະພັນ",
    seckill: "ການຂາຍດ່ວນ",
    daySeckill: "ເວລາການຂາຍດ່ວນປະຈຳວັນ",

    cutDownTips: "ການນັບຖອຍຫຼັງການຂາຍກ່ອງຕາບອດໃນເວລາຈຳກັດ",

    cutDownTips1: "ການຂາຍກ່ອງຕາບອດສິ້ນສຸດລົງແລ້ວ",

    cutDownTips2: "ການຂາຍກ່ອງຕາບອດບໍ່ຢູ່ໃນຂອບເຂດເວລາ",

    cutDownTips3: "ກິດຈະກຳຍັງບໍ່ເລີ່ມຕົ້ນ",
  },
  detail: {
    detail_a: "ກັບຄືນໄປໜ້າຫຼັກ",

    detail_b: "ຮຸ່ນ",

    detail_c: "ຈຳນວນ",

    detail_d: "ຄຳແນະນຳໃນການແລກຂອງຂວັນ",

    detail_e:
      "ຂອງຂວັນຈະຖືກຈັດສົ່ງພາຍໃນ 15 ມື້ຫຼັງຈາກໃບສະໝັກແລກຂອງທ່ານໄດ້ຮັບການອະນຸມັດ. ກະລຸນາກວດສອບອີເມວຂອງທ່ານ. ທ່ານຍັງສາມາດຕິດຕໍ່ຜູ້ຈັດການບໍລິການລູກຄ້າສະເພາະຂອງທ່ານເພື່ອກວດສອບຄວາມຄືບໜ້າຂອງການຈັດສົ່ງໄດ້.",

    detail_f:
      "ລາຍການທັງໝົດທີ່ລະບຸໄວ້ໃນ Points Mall ແມ່ນສະໜອງໃຫ້ໂດຍຜູ້ສະໜອງພາກສ່ວນທີສາມ ແລະ ບໍ່ຮອງຮັບການສົ່ງຄືນໂດຍບໍ່ມີເຫດຜົນ. ຢ່າງໃດກໍຕາມ, ຖ້າຂອງຂວັນທີ່ບໍ່ຖືກຕ້ອງຖືກສົ່ງ ຫຼື ເສຍຫາຍໃນລະຫວ່າງການຈັດສົ່ງ, ກະລຸນາຕິດຕໍ່ບໍລິການລູກຄ້າສະເພາະຂອງທ່ານເພື່ອຂໍຄວາມຊ່ວຍເຫຼືອ.",

    detail_g: "ລາຍລະອຽດຜະລິດຕະພັນ",

    detail_h: "ຄຳແນະນຳທີ່ນິຍົມ",

    detail_i: "ກະລຸນາເຂົ້າສູ່ລະບົບ",
  },
  settlement: {
    balance: "ຍອດຄະແນນຄົງເຫຼືອ",

    settlement_a: "ຂໍ້ມູນການສັ່ງຊື້",

    settlement_b: "ຊື່",

    settlement_c: "ລາຍລະອຽດສະເພາະ",

    settlement_d: "ລາຄາຕໍ່ໜ່ວຍ",

    settlement_e: "ຈຳນວນ",

    settlement_f: "ຂໍ້ມູນຜູ້ຮັບ",

    settlement_g: "ເພີ່ມທີ່ຢູ່",

    settlement_h: "ຈຳນວນເງິນທີ່ຕ້ອງຈ່າຍ",

    settlement_i: "ຄະແນນ",

    settlement_z: "ສົ່ງດຽວນີ້",

    settlement_k: "ການສົ່ງສຳເລັດແລ້ວ",

    settlement_l: "ກະລຸນາຢືນຢັນການສັ່ງຊື້ຂອງທ່ານ!",

    settlement_m: "ຜະລິດຕະພັນ",

    settlement_n: "ຂໍ້ມູນຜະລິດຕະພັນ!",

    settlement_o: "ຂໍ້ມູນຄະແນນ!",

    settlement_p: "ຕ້ອງການຄະແນນບໍ່ພຽງພໍ",

    settlement_title: "ແລກສຳເລັດແລ້ວ!",

    settlement_tip:
      "ຄຳສັ່ງຊື້ແລກຂອງທ່ານຈະຖືກຈັດສົ່ງພາຍໃນ 15 ມື້ເຮັດວຽກ. ທ່ານຍັງສາມາດຕິດຕໍ່ຜູ້ຈັດການບໍລິການລູກຄ້າຂອງທ່ານເພື່ອກວດສອບຄວາມຄືບໜ້າຂອງການຈັດສົ່ງໄດ້.",

    settlement_button: "ຢືນຢັນ",

    settlement_button_err: "ຢືນຢັນ",

    settlement_tip_error:
      "ວິທີການສະສົມຄະແນນ: ຊື້ຂາຍຄູ່ສະກຸນເງິນ, ໂລຫະທີ່ມີຄ່າ, ແລະຜະລິດຕະພັນພະລັງງານ. ທ່ານຈະໄດ້ຮັບ 1 ຄະແນນສຳລັບທຸກໆ lot ທີ່ຊື້ຂາຍ (ຄຳສັ່ງຊື້ທີ່ຖືກເກັບຮັກສາໄວ້ຫຼາຍກວ່າສາມນາທີຖືວ່າຖືກຕ້ອງ)",
  },

  meber: {
    meber_a: "ສູນຄຳສັ່ງຊື້",
    meber_b: "ສູນສ່ວນຕົວ",
    meber_c: "ຄຳສັ່ງຊື້ຂອງຂ້ອຍ",
    meber_d: "ການຈັດການທີ່ຢູ່",
    meber_e: "ອອກຈາກລະບົບ",
  },
  address: {
    address_a: "ເພີ່ມ",
    address_b: "ຊື່",
    address_c: "ເບີໂທລະສັບ",
    address_d: "ທີ່ຢູ່",
    address_e: "ການດຳເນີນງານ",
    address_f: "ແກ້ໄຂ",
    address_g: "ລຶບ",
    address_h: "ກະລຸນາເລືອກ",
    address_i: "ທີ່ຢູ່ລະອຽດ",
    address_j: "ບັນທຶກ",
    address_k: "ກະລຸນາໃສ່ຊື່",
    address_l: "ກະລຸນາໃສ່ເບີໂທລະສັບມືຖື",
    address_m: "ຮູບແບບເບີໂທລະສັບມືຖືບໍ່ຖືກຕ້ອງ",
    address_n: "ກະລຸນາໃສ່ເບີໂທລະສັບມືຖື",
    address_o: "ກະລຸນາໃສ່ທີ່ຢູ່ລະອຽດ",
    address_p: "ການດັດແປງສຳເລັດ",
    address_q: "ເພີ່ມສຳເລັດແລ້ວ",
    address_r: "ລຶບສຳເລັດແລ້ວ",
    address_s: "ເພີ່ມທີ່ຢູ່ຈັດສົ່ງແລ້ວ",
    address_t: "ທ່ານຍັງບໍ່ທັນໄດ້ເພີ່ມທີ່ຢູ່ຈັດສົ່ງເທື່ອ",
  },

  order: {
    order_a: "ຄຳສັ່ງຊື້ຂອງຂ້ອຍ",

    order_b: "ວັນທີ",

    order_c: "ເລກທີ່ສັ່ງຊື້",

    order_d: "ຜູ້ຮັບ",

    order_e: "ຈຳນວນເງິນ",

    order_f: "ລາຍລະອຽດການສັ່ງຊື້",

    order_g: "ເບີໂທລະສັບ",

    order_h: "ທີ່ຢູ່",

    order_i: "ສະຖານະ",

    order_j: "ວິທີການຂົນສົ່ງ",

    order_k: "ການດຳເນີນງານ",

    order_l: "ປິດແລ້ວ",

    order_m: "ສ້າງແລ້ວ",

    order_n: "ຈ່າຍແລ້ວ",

    order_o: "ກຳລັງດຳເນີນການຄືນເງິນ",

    order_p: "ການຄືນເງິນສຳເລັດແລ້ວ",

    order_q: "ສົ່ງແລ້ວ",

    order_r: "ສຳເລັດແລ້ວ",

    order_s: "ໃຊ້ຄະແນນແລ້ວ",
  },

  userinfo: {
    userinfo_a: "ສູນສ່ວນຕົວ",

    userinfo_b: "ເວລາອັບເດດຄັ້ງສຸດທ້າຍ",

    userinfo_c: "ຜູ້ໃຊ້ ອີເມວ",

    userinfo_d: "ຄະແນນທີ່ມີຢູ່",
  },

  orderDetail: {
    orderDetail_a: "ສົ່ງຄຳສັ່ງຊື້",

    orderDetail_b: "ການຈ່າຍເງິນສຳເລັດ",

    orderDetail_c: "ສິນຄ້າໝົດສະຕັອກ",

    orderDetail_d: "ລໍຖ້າໃບຮັບເງິນ",

    orderDetail_e: "ສຳເລັດແລ້ວ",

    orderDetail_f: "ວິທີການຊຳລະເງິນ",

    orderDetail_g: "ວິທີການຂົນສົ່ງ",

    orderDetail_h: "ເລກຕິດຕາມ",
  },

  footerbox: {
    footerbox_b: "ຕະຫຼາດໂລກໃນປະຈຸບັນ",

    footerbox_c: "ລອງໃຊ້ສາທິດຟຣີ",

    footerbox_d: "ບໍລິການລູກຄ້າອາຊີປາຊີຟິກ (ສິງກະໂປ)",

    footerbox_e: "ອີເມວບໍລິສັດ",

    footerbox_f: "support@interstellarsfx.com",

    footerbox_g: "ເລີ່ມຕົ້ນ ການຊື້ຂາຍ",

    footerbox_h: "Forex",
    footerbox_i: "ໂລຫະທີ່ມີຄ່າ",
    footerbox_ik: "ຫຸ້ນ",
    footerbox_j: "ພະລັງງານ",
    footerbox_k: "ດັດຊະນີ",
    footerbox_a: "ກ່ຽວກັບການຊື້ຂາຍ",
    footerbox_l: "ບັນຊີ",
    footerbox_m: "ປະເພດບັນຊີ",
    footerbox_ml: "ນະໂຍບາຍການໃຊ້ສິດເລເວີເຣນ",
    footerbox_n: "ເງິນຝາກ ແລະ ການຖອນເງິນ",
    footerbox_o: "ເປີດບັນຊີສົດ",
    footerbox_p: "ເປີດບັນຊີສາທິດ",
    footerbox_q: "ເຄື່ອງມືການຊື້ຂາຍ",
    footerbox_r: "MetaTrader 4",
    footerbox_s: "MAM",
    footerbox_t: "MultiTerminal",
    footerbox_u: "ປະຕິທິນເສດຖະກິດ",
    footerbox_v: "Forex ເຄື່ອງຄິດໄລ່",
    footerbox_w: "VPS",
    footerbox_x: "ການວິເຄາະດ້ານວິຊາການ",

    footerbox_y: "ສະຖາບັນການຄ້າ",

    footerbox_z: "ຄຳສັບການຄ້າ",

    footerbox_aa: "ກ່ຽວກັບ Interstellar",

    footerbox_ad: "ກ່ຽວກັບພວກເຮົາ",

    footerbox_bb: "ຂ່າວ",

    footerbox_cc: "ການຮັບສະໝັກ",

    footerbox_dd: "ຕິດຕໍ່ພວກເຮົາ",

    footerbox_ee: "ຄູ່ຮ່ວມງານ",

    footerbox_ff: "ຄຳຖາມທີ່ຖືກຖາມເລື້ອຍໆ",

    footerbox_mm: "ຂໍ້ຄວາມປະຕິເສດຄວາມຮັບຜິດຊອບ:",

    footerbox_nn: `ເວັບໄຊທ໌ www.interstellarsfx.com ດຳເນີນການໂດຍ First Interstellar Global Ltd, ເຊິ່ງເປັນບໍລິສັດຈຳກັດທີ່ຈົດທະບຽນພາຍໃຕ້ກົດໝາຍຂອງ Seychelles, ມີສຳນັກງານທີ່ຈົດທະບຽນຢູ່ທີ່ຫ້ອງ 9, ອາຄານ Deenu's, Providence, Mahe, Seychelles. First Interstellar Global Ltd ໄດ້ຮັບອະນຸຍາດ ແລະ ຄວບຄຸມໂດຍ Seychelles Financial Services Authority, ເລກທີ່ຄວບຄຸມ SD127. First Interstellar Global Ltd ບໍ່ໄດ້ຢູ່ໃນຂອບການຄຸ້ມຄອງທາງດ້ານການເງິນຂອງເອີຣົບ; ຄຳສັ່ງກ່ຽວກັບເຄື່ອງມືທາງການເງິນຂອງຕະຫຼາດ (MiFID) II ແລະ ກົດລະບຽບການບໍລິການທາງການເງິນອື່ນໆຂອງເອີຣົບບໍ່ໄດ້ນຳໃຊ້ກັບການບໍລິການທາງການເງິນທີ່ສະເໜີໂດຍ First Interstellar Global Ltd., ແລະ ບໍ່ມີໂຄງການຊົດເຊີຍສຳລັບນັກລົງທຶນ.`,

    footerbox_gg:
      "InterstellarFX ບໍ່ໄດ້ສະເໜີການຊື້ຂາຍ CFD ໃຫ້ແກ່ຜູ້ຢູ່ອາໄສໃນບາງເຂດອຳນາດ, ລວມທັງສະຫະລັດອາເມລິກາ, ອີຣ່ານ, ການາດາ, ແບນຊິກ, ແລະ ຝຣັ່ງ.",

    footerbox_hh: "ຄຳເຕືອນຄວາມສ່ຽງ:",

    footerbox_ii:
      "ການຊື້ຂາຍ forex ແລະ ເຄື່ອງມືທາງການເງິນທີ່ມີ leveraged ມີຄວາມສ່ຽງສູງ ແລະ ອາດຈະເຮັດໃຫ້ສູນເສຍເງິນຕົ້ນທຶນຂອງທ່ານ., ທ່ານບໍ່ຄວນມີຄວາມສ່ຽງຫຼາຍກວ່າທີ່ທ່ານສາມາດສູນເສຍໄດ້, ແລະ ກະລຸນາຮັບປະກັນວ່າທ່ານເຂົ້າໃຈຢ່າງເຕັມສ່ວນກ່ຽວກັບຄວາມສ່ຽງທີ່ກ່ຽວຂ້ອງ.ການຊື້ຂາຍຜະລິດຕະພັນທີ່ມີ leveraged ບໍ່ເໝາະສົມກັບນັກລົງທຶນທຸກຄົນ.ການຊື້ຂາຍຜະລິດຕະພັນທີ່ບໍ່ມີ leveraged(ເຊັ່ນ: ຫຸ້ນ) ຍັງມີຄວາມສ່ຽງ, ຍ້ອນວ່າມູນຄ່າຂອງຫຸ້ນສາມາດຂຶ້ນ ຫຼື ລົງ, ຊຶ່ງໝາຍຄວາມວ່າທ່ານອາດຈະໄດ້ຮັບເງິນຄືນໜ້ອຍກວ່າການລົງທຶນເບື້ອງຕົ້ນຂອງທ່ານ.ຜົນງານໃນອະດີດບໍ່ແມ່ນການຮັບປະກັນຜົນໄດ້ຮັບໃນອະນາຄົດ.ກ່ອນການຊື້ຂາຍ, ໃຫ້ພິຈາລະນາລະດັບປະສົບການ, ຈຸດປະສົງການລົງທຶນຂອງທ່ານ, ແລະ ຊອກຫາຄໍາແນະນໍາທາງດ້ານການເງິນທີ່ເປັນເອກະລາດຖ້າຈໍາເປັນ.ລູກຄ້າມີຄວາມຮັບຜິດຊອບໃນການຮັບປະກັນວ່າກົດໝາຍຂອງປະເທດທີ່ເຂົາເຈົ້າອາໄສຢູ່ອະນຸຍາດໃຫ້ໃຊ້ບໍລິການທີ່ Star Brand ສະໜອງໃຫ້.",

    footerbox_zz: "ຖະແຫຼງຄວາມສ່ຽງ",

    footerbox_kk: "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",

    footerbox_ll: "ລິຂະສິດ © 2025 FISG. ສະຫງວນລິຂະສິດທຸກປະການ.",
  },
  other: {
    sections: {
      about: "ກ່ຽວກັບ FISG",
      trading: "ການຊື້ຂາຍ",
      campaigns: "ແຄມເປນ",
      education: "ການສຶກສາ",
      markets: "ຕະຫຼາດ",
    },
    about: {
      title: "First InterStellar Group",
      aboutFISG: "ກ່ຽວກັບ FISG",
      legalCompliance: "ການປະຕິບັດຕາມກົດໝາຍ",
      clientReviews: "ຄຳຄິດເຫັນຂອງລູກຄ້າ",
      insurance: "ປະກັນໄພ",
      events: "ກິດຈະກຳ InterStellar",
      partnership: "ຄູ່ຮ່ວມງານ",
    },
    trading: {
      platformTitle: "ແພລດຟອມການຊື້ຂາຍ",
      mt4: "MetaTrader 4",
      mt5: "MetaTrader 5",
      webTerminal: "MetaTrader WebTerminal",
      copyTrade: "Copy Trade",
      app: "FISG APP",
      marketsTitle: "ຕະຫຼາດສຳລັບການຊື້ຂາຍ",
      forex: "Forex",
      metals: "ໂລຫະມີຄ່າ",
      energy: "ພະລັງງານ",
      index: "ດັດຊະນີ",
      stock: "ຫຸ້ນ",
      cryptocurrency: "ເງິນດິຈິຕອນ",
      accountTitle: "ບັນຊີ",
      accountTypes: "ປະເພດບັນຊີ",
      leverage: "ນະໂຍບາຍການເປີດ Leverage",
      depositWithdrawal: "ຝາກ ແລະ ຖອນເງິນ",
      toolsTitle: "ເຄື່ອງມືການຊື້ຂາຍ",
      mam: "MAM",
      pamm: "PAMM",
      multiTerminal: "MultiTerminal",
      calculator: "ເຄື່ອງຄິດໄລ່ Forex",
    },
    campaigns: { title: "ແຄມເປນ" },
    education: {
      title: "ການສຶກສາ",
      seminar: "ສຳມະນາ",
      whatIsForex: "ການຊື້ຂາຍ Forex ແມ່ນຫຍັງ?",
      course: "ຫຼັກສູດການຊື້ຂາຍ",
      investment: "ການລົງທຶນ Forex",
      glossary: "ສັບຕ່າງໆຂອງການຊື້ຂາຍ",
      faq: "ຄຳຖາມທີ່ພົບເລື້ອຍ",
    },
    markets: {
      title: "ຕະຫຼາດ",
      notices: "ປະກາດຂອງ FISG",
      analysis: "ການວິເຄາະຂອງ FISG",
      calendar: "ປະຕິທິນເສດຖະກິດ",
      transaction: "ການວິເຄາະທຸລະກຳ",
      news: "ຂ່າວດ່ວນ",
      times: "FISG Times",
      marketWrap: "Market Wrap",
    },
    ctaTradeNow: "ຊື້ຂາຍດຽວນີ້",
    login: "ເຂົ້າສູ່ລະບົບ",

    topTips1: "1 ຈຸດເທົ່າກັບ 1 lot ມາດຕະຖານ ຫຼື 100 ໂດລາສະຫະລັດ.",

    topTips2: "ບໍ່ຍອມຮັບການແລກປ່ຽນລະຫວ່າງພາກພື້ນ.",

    topTips3:
      "ຂ້ອຍໄດ້ຢືນຢັນວ່າປະລິມານການເຮັດທຸລະກໍາຕົວຈິງແມ່ນຄືກັນກັບຈຸດການເຮັດທຸລະກໍາທີ່ສະແດງໂດຍລະບົບນີ້, ແລະ ການແລກໄດ້ສໍາເລັດແລ້ວ.",

    topTips4:
      "ຂ້ອຍເຂົ້າໃຈວ່າຖ້າຈຸດການເຮັດທຸລະກໍາຖືກສະແດງບໍ່ຖືກຕ້ອງຍ້ອນຄວາມຜິດພາດຂອງລະບົບ, ການແລກນີ້ຈະໝົດອາຍຸໂດຍອັດຕະໂນມັດ.",
    remark: "ໝາຍເຫດ",

    confirmAddress: "ຢືນຢັນທີ່ຢູ່",
    cancel_btn: "ຍົກເລີກ",

    setAsDefault: "ຕັ້ງເປັນຄ່າເລີ່ມຕົ້ນ",
    exchangeAccount: "ບັນຊີແລກປ່ຽນ",

    defaultAddress: "ຄ່າເລີ່ມຕົ້ນ",

    exchangeAccount1: "ເລືອກບັນຊີການຊື້ຂາຍ",

    exchangeAccount2: "ເລືອກບັນຊີການຊື້ຂາຍເພື່ອຮັບລາງວັນເງິນສົດ",
  },
}
